export default "__VITE_ASSET__e52db793__"